<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('preInvoiceList.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('preInvoiceList.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('preInvoiceList.criteria') }}</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('preInvoiceList.branchName')
											}}</label>
											<a-select style="width: 100%" v-model.number="model.branch_id" :options="branches"></a-select>
											<div class="validate" v-if="errors.has('branch_id')">
												{{ errors.first('branch_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('preInvoiceList.acYear')
											}}</label>
											<a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
												@change="acYearChange"></a-select>
											<div class="validate" v-if="errors.has('ac_year_id')">
												{{ errors.first('ac_year_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('preInvoiceList.subProgram')
											}}</label>

											<a-select style="width: 100%" :maxTagCount="1" v-model="model.acps_id" :options="sub_programs"
												:show-search="true" :limit="1" mode="multiple" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" @change="onSubChange" :disabled="!model.ac_year_id"></a-select>

										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('preInvoiceList.acTerm') }}</label>
											<br>
											<a-radio-group v-model="model.ac_status_id" size="small" @change="onAcStatusChange">
												<a-radio :value="1" style="font-size: 13px">Current</a-radio>
												<a-radio :value="2" style="font-size: 13px">History</a-radio>
												<a-radio :value="3" style="font-size: 13px">Next</a-radio>
											</a-radio-group>
											<a-select :maxTagCount="1" style="width: 100%" v-model="model.ac_term_id" :options="ac_terms"
												:show-search="true" :limit="1" mode="multiple" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0" 
														@change="acTermChange" 
														class="mt-3"
											>
											</a-select>

										</div>
									</div>

									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('preInvoiceList.classOperation')
											}}</label>
											<a-select style="width: 100%" :maxTagCount="1" v-model="model.class_id" :options="class_options"
												:show-search="true" :limit="1" mode="multiple" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													"></a-select>

										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('preInvoiceList.paymentStatus') }}</label>
											<a-select v-model="model.status_id" :options="statuses" showSearch mode="multiple" :filterOption="(input, option) =>
												option.componentOptions.children[0].text
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
												" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
											</a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('preInvoiceList.status') }}</label>
											<div>
												<a-radio-group v-model="model.is_deleted">
													<a-radio :value="0" style="font-size: 13px">Active</a-radio>
													<a-radio :value="1" style="font-size: 13px">Voided</a-radio>
												</a-radio-group>

											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('preInvoiceList.date')
											}}</label>
											<a-range-picker style="width:100%" v-model="model.date_range" format="DD-MM-YYYY"
												valueFormat="YYYY-MM-DD" />
											<div class="validate" v-if="errors.has('date_range')">
												{{ errors.first('date_range') }}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 text-right">
											<ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
												$t('preview') }}</ts-button>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('preInvoiceList.previewPdf') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'preInvoiceList',
	data() {
		return {
			loading: false,
			waiting: false,
			src: '',
			errors: new Errors(),
			branches: [],
			ac_year_list: [],
			sub_programs: [],
			ac_terms: [],
			class_options: [],
			model: {
				branch_id: null,
				acps_id: [],
				ac_term_id: [],
				ac_year_id: null,
				class_id: [],
				status_id: [],
				is_deleted: 0,
				date_range: [],
				ac_status_id: undefined
			},

			statuses: [
				{
					value: 1,
					label: 'Paid'
				},
				{
					value: 0,
					label: 'Unpaid'
				}
			],
		}
	},
	created() {
		this.fetchResource()
	},
	methods: {
		...mapActions('reportPayment', [
			'getBranch',
			'getYear',
			'getSubProgram',
			'getTerm',
			'getClass',
			'preInvoiceList'
		]),
		async fetchResource() {
			this.loading = true
			await this.getBranch().then(response => {
				this.branches = response.data.map(el => ({
					value: el.branch_id,
					label: el.branch_name_en
				}))
				this.model.branch_id = this.$store.state.authUser.default_branch_id
			})
			await this.getSubProgram()
				.then(response => {
					this.sub_programs = response.data.map(el => ({
						value: el.acps_id,
						label: el.acps_name_foreign
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onBranchChange() {
			this.model.ac_year_id = null
			this.model.acps_id = []
			this.model.ac_term_id = []
			this.ac_terms = []
			this.class_options = []
			this.fetching = true
			this.getYear({
				filter: {
					ac_status_id: '1,2,3',
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
						el => ({
							value: el.ac_year_id,
							label:
								el.ac_year +
								(el.ac_status_id == 1
									? ' ( Current ) '
									: el.ac_status_id == 2
										? ' ( History ) '
										: ' ( Next ) ')
						})
					)
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching = false
				})
		},
		onSubChange(_value) {
			this.model.ac_term_id = []
			this.model.class_id = []
			this.ac_terms = []
			this.class_options = []
			this.loading = true
			this.fetchTerm().finally(() => { this.loading = false })
		},
		onAcStatusChange() {
			this.loading = true
			this.model.ac_term_id = []
			this.ac_terms = []
			this.model.class_id = []
			this.class_options = []
			this.fetchTerm().finally(() => { this.loading = false })
		},
		fetchTerm() {
			return this.getTerm({
				filter: {
					acps_id: this.model.acps_id,
					ac_status_id: this.model.ac_status_id,
					ac_year_id: this.model.ac_year_id,
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_terms = _.sortBy(response.data, ['ac_status_id']).map(el => ({
						value: el.ac_term_id,
						label:
							el.term_name +
							(el.ac_status_id == 1
								? ' ( Current ) '
								: el.ac_status_id == 2
									? ' ( History ) '
									: '( Next )')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
		},
		acYearChange() {
			this.model.acps_id = []
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		acTermChange(ac_term_id) {
			this.loading = true
			this.model.class_id = []
			this.class_options = []
			this.getClass({
				filter: {
					ac_term_id: ac_term_id,
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.class_options = response.data.map(el => ({
						value: el.class_id,
						label:
							el.class_name +
							' | ' +
							el.teacher.full_name_en +
							' | ' +
							el.academic_study_time.study_time
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.preInvoiceList(this.model)
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})

		}
	},
	watch: {
		'model.branch_id': function (val) {
			if (val) {
				this.onBranchChange()
			}
		}

	}
}
</script>